import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import UnleashYourPotential from "./sections/UnleashYourPotential";
import TheTribeVibe from "./sections/TheTribeVibe";
import WhatWeDo from "./sections/WhatWeDo";
import ImpactByTheNumbers from "./sections/ImpactByTheNumbers";
import VoicesOfTheTribe from "./sections/VoicesOfTheTribe";
import JoinTheTribe from "./sections/JoinTheTribe";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <UnleashYourPotential />
      <TheTribeVibe />
      <WhatWeDo />
      <ImpactByTheNumbers />
      <VoicesOfTheTribe />
      <JoinTheTribe />
      <Footer />
    </div>;
}